/** Model B pricing helpers (preview POR CARTA — no incluye envío).
 * Buyer pays exactly `price + shipping`. Seller absorbs HitTCG (tier-based)
 * + Payphone (5.75%). ⚠️ Feb 2026: Payphone real se calcula sobre
 * (precio + envío) al momento del checkout. Esta preview solo aproxima el
 * neto POR CARTA (sin envío ni la porción de Payphone del envío) — el
 * vendedor ve el desglose completo con envío en el detalle de cada orden.
 *
 *   net_seller_card = price − hittcg − payphone_on_price   (preview)
 *   seller_receives_real = net_seller_card + shipping − payphone_on_shipping  (en orden real)
 *
 * `tiers` es el array de GET /config/public → commission_tiers.
 */
export function sellerNetFor(price, tiers) {
  const p = Number(price) || 0;
  if (p <= 0) return { price: 0, hittcg: 0, payphone: 0, net: 0, activeTier: null };
  let activeTier = null;
  if (tiers && tiers.length) {
    for (let i = 0; i < tiers.length; i++) {
      const t = tiers[i];
      if (t.max === null || t.max === undefined || p <= t.max) {
        activeTier = t;
        break;
      }
    }
  }
  const rawFee = activeTier ? p * (activeTier.pct / 100) : p * 0.10;
  const minFee = activeTier?.min_fee ?? 0;
  const minFeeApplied = activeTier ? rawFee < minFee : false;
  const hittcg = Math.max(rawFee, minFee);
  const payphone = p * 0.0575;
  const net = Math.max(0, p - hittcg - payphone);
  return {
    price: p,
    hittcg: Number(hittcg.toFixed(2)),
    payphone: Number(payphone.toFixed(2)),
    net: Number(net.toFixed(2)),
    activeTier,
    minFeeApplied,
    minFee: Number((minFee || 0).toFixed(2)),
  };
}
